export enum DirectionDocumentEnum {
    INCOMING = 'INCOMING',
    OUTGOING = 'OUTGOING'
}
